import 'angular';
import 'angular-resource';
import 'jquery';
import '../../../../../lib/assets/javascripts/devex/urls';
import template from './search_bar.template.html?raw';
import donorListModalTemplate from '../modals/donor_list_modal.template.html?raw';
import routesModule from '../../../utilities/routes_module';
import modal from 'angular-ui-bootstrap/src/modal';
import typeahead from 'angular-ui-bootstrap/src/typeahead';
import '../components/lifecycle.component';
import '../../../../assets/javascripts/funding/shared/date_filter.service';
import { mapTextToName, pluckData, toNumericId, uniqByName } from '../../../utilities/request_transformers';

const moduleDependencies = [
  'fundingSearchApp.components.lifecycle',
  modal,
  typeahead,
  'ngResource',
  'fundingSearchApp.services.dateFilterService',
];

angular.module('fundingSearchApp.directives.searchBar', moduleDependencies)
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
    $templateCache.put(donorListModalTemplate, donorListModalTemplate);
  }])
  .directive('searchBar', [
    '$resource',
    '$uibModal',
    '$http',
    'dateFilterService',
    ($resource, $uibModal, $http, dateFilterService) => {
      const link = ($scope) => {
        $scope.isInputExpanded = false;
        $scope.dropdowns = {
          advancedFiltersOpen: false,
          customDatePickerExpanded: false,
        };

        const placeAutocomplete = $resource(
          routesModule.api_autocomplete_path('places'),
          {},
          {
            get: {
              method: 'GET',
              isArray: true,
              transformResponse: [
                angular.fromJson,
                pluckData,
                toNumericId,
                mapTextToName,
                uniqByName,
              ],
            },
          }
        );

        const donorAutocomplete = $resource(
          routesModule.api_autocomplete_path('donors'),
          {},
          {
            get: {
              method: 'GET',
              isArray: true,
              transformResponse: [angular.fromJson, pluckData, mapTextToName],
            },
          }
        );

        $scope.inputModels = {
          places: null,
          news_topics: null,
          donors: null,
          exclude_donors: null,
          donor_categories: null,
        };

        /**
         * filterContainsValue: returns true if the provided value already exists
         * as a filter in the provided filterType.
         *
         * @param {object} value - object containing filter value
         * @param {string} filterType - name of the filter (e.g. 'news_topics')
         *
         * @returns {boolean} true if filter already exists, otherwise false
         */
        $scope.filterContainsValue = (value, filterType) => {
          const key = ['donors', 'exclude_donors'].includes(filterType) ? 'short_name' : 'name';
          return $scope.searchJs.filter[filterType].value.some((item) => item[key] === value[key]);
        };

        /**
         * onSelect callback for adding a filter parameter.
         * Sets the current state of the input value to null
         * Adds the filter to searchJS
         * Makes a new search
         *
         * @param {object} value - object containing filter value
         * @param {string} filterType - name of the filter (e.g. 'news_topics')
         *
         * @returns {undefined}
         */
        $scope.onFilterSelect = (value, filterType) => {
          $scope.inputModels[filterType] = null;
          if ($scope.filterContainsValue(value, filterType)) {
            return;
          }
          $scope.searchJs.filter[filterType].addValue(value);
          $scope.searchJs.notifyParamChange();
        };

        /**
         * onDeselect callback for removing a filter parameter.
         * calls the searchJS.removeValue function to remove the given filter value
         * Makes a new search
         *
         * @param {object} value - object containing filter value
         * @param {string} filterType - name of the filter (e.g. 'news_topics')
         *
         * @returns {undefined}
         */
        $scope.onFilterDeselect = (value, filterType) => {
          const removeValue = ((filter) => {
            switch (filter) {
              case 'donors':
              case 'exclude_donors':
                return value.short_name;
              case 'donor_categories':
                return value.name;
              default:
                return value;
            }
          })(filterType);
          $scope.searchJs.filter[filterType].removeValue(removeValue);
          $scope.searchJs.notifyParamChange();
        };

        /**
         * getPlaces returns array of places given a filter string.
         * filters currently active filter values.
         *
         * @param {string} filter - filter value passed to the autocomplete
         *
         * @returns {Array} array of places
         */
        $scope.getPlaces = (filter) => {
          return placeAutocomplete
            .get({ q: filter, 'types[]': ['country', 'region'] })
            .$promise.then((items) =>
              items.filter((value) => !$scope.filterContainsValue(value, 'places'))
            );
        };

        /**
         * getDonors returns array of donors given a filter string
         * filters currently active filter values.
         *
         * @param {string} filter - filter value passed to the autocomplete
         *
         * @returns {Array} array of donors
         */
        $scope.getDonors = (filter) => {
          return donorAutocomplete
            .get({ q: filter })
            .$promise.then((items) =>
              items.filter((value) => !$scope.filterContainsValue(value, 'donors'))
            );
        };

        /**
         * Create $scope.checkboxFilters variable once SearchJs is initialized correctly
         *
         * @returns {undefined}
         */
        const defineCheckboxFilters = () => {
          $scope.checkboxFilters = [
            {
              filter: $scope.searchJs.filter.categories,
              name: 'categories',
              uniqueId: 'categories',
              display_name: 'Category',
              options: ['Services', 'Goods', 'Works'],
              index: 0,
            },
            {
              filter: $scope.searchJs.filter.opportunity_sizes,
              name: 'opportunity_sizes',
              uniqueId: 'opportunity_sizes',
              display_name: 'Opportunity size',
              options: ['small', 'medium', 'large'],
              index: 1,
            },
            {
              filter: $scope.searchJs.filter.statuses,
              name: 'statuses',
              uniqueId: 'statuses',
              display_name: 'Status',
              options: ['forecast', 'open', 'closed', 'postponed', 'cancelled'],
              index: 2,
            },
            {
              filter: $scope.searchJs.filter.type,
              name: 'type',
              uniqueId: 'tgoTypeFilter',
              display_name: 'Type',
              options: ['tender', 'grant', 'open_opportunity'],
              index: 3,
            },
            {
              filter: $scope.searchJs.filter.type,
              name: 'type',
              uniqueId: 'contractTypeFilter',
              display_name: 'Type',
              options: ['contract', 'shortlist'],
              index: 4,
            },
            {
              filter: $scope.searchJs.filter.source_type,
              name: 'source_type',
              uniqueId: 'source_type',
              display_name: 'Source',
              options: ['news', 'operational_document', 'strategic_document', 'devex'],
              index: 5,
            },
          ];
        };

        /**
         * Binds the searchJs filter values to the checkboxFilters.options
         *
         * @returns {undefined}
         */
        const bindCheckboxFiltersOptionsWithSearchJsFilters = () => {
          $scope.checkboxFilters.forEach((item) => {
            item.options.forEach((option) => {
              option.checked = item.filter.containsValue(option.name);
            });
          });
        };

        /**
         * As displayed name of some options we want to display will be different from the actual
         * SearchJs value, add a switch logic to determine which option name needs to be mapped.
         *
         * @param {string} optionName - The name of the option
         *
         * @returns {string} - Name of the option we will ultimately display (it will be
         * also be humanized in the view)
         */
        const defineDisplayNameForCheckboxOption = (optionName) => {
          switch (optionName) {
            case 'small':
              return 'Under 1 million';
            case 'medium':
              return '1 to 5 million';
            case 'large':
              return 'Above 5 million';
            case 'strategic_document':
              return 'Country strategy documents';
            default:
              return optionName;
          }
        };

        /**
         * Parses the checkboxFilters.options in order to add a checked
         * property to each option
         *
         * @returns {undefined}
         */
        const parseCheckboxFilter = () => {
          $scope.checkboxFilters.forEach((item) => {
            item.options = item.options.map((option) => ({
              name: option,
              displayName: defineDisplayNameForCheckboxOption(option),
              checked: false,
            }));
          });

          bindCheckboxFiltersOptionsWithSearchJsFilters();
        };

        $scope.humanize = devex.util.humanize;
        $scope.isSignedIn = devex.data.userSignedIn;

        /**
         * It sorts by Relevance and filter by `Last week` in case text input contains text
         * and triggers a search
         *
         * @returns {undefined}
         *
         **/
        $scope.applyTextFilter = () => {
          if ($scope.searchJs.filter.query.isActive()) {
            $scope.searchJs.sorting.setParams({
              sorting: { name: 'Relevance', field: '_score', order: 'desc' },
            });
            $scope.dateFilterService.setDateIfNoDate('last_month');
          }
          $scope.dropdowns.advancedFiltersOpen = false;
          $scope.searchJs.notifyParamChange();
        };

        /**
         * Open custom datepicker menu and generate GA event
         *
         * @returns {undefined}
         *
         **/
        $scope.openCustomDatepicker = () => {
          $scope.dropdowns.customDatePickerExpanded = true;
        };

        /**
         * Close custom datepicker menu and clear SearchJs `updated_since` filter. Notify SearchJs
         * to run new search accordingly.
         *
         * @returns {undefined}
         *
         **/
        $scope.closeCustomDatepickerAndClear = () => {
          $scope.dateFilterService.setDate('reset', true);
          $scope.hideCustomDatepicker();
        };

        /**
         * Simply hide custom datepicker menu.
         *
         * @returns {undefined}
         *
         **/
        $scope.hideCustomDatepicker = () => {
          $scope.dropdowns.customDatePickerExpanded = false;
        };

        /**
         * Toggles checkbox filter, applies or removes corresponding value in SearchJs filter,
         * passed as argument of this function. Generate GA event. Finally, notify param change
         * to SearchJs.
         *
         * @param {object} filter - SearchJs filter used together with sub-filter UI
         * @param {object} option - Option object with different properties
         * @param {boolean} option.checked - True if option should be active in SearchJs filter
         * @param {string} option.name - Value of filter (e.g. 'Works' for categories filter)
         *
         * @returns {undefined}
         *
         **/
        $scope.toggleCheckboxFilter = (filter, option) => {
          let action = 'removeValue';

          if (option.checked) {
            action = 'addValue';
          }

          filter[action](option.name);
          $scope.searchJs.notifyParamChange(filter.name);
        };

        /**
         * Show sub-filter depending on what report types are currently active. If type filter is
         * inactive (which means all type filters are returned by BE) we should then show all
         * sub-filters.
         * If both TGO and Program type are active, show the common sub-filters.
         * Note that there is a special behavior for filters that modifies the type report, since
         * we have two of them in the UI, one for TGO, one for Contract/shortlist. That's
         * why we introduced the concept of `uniqueId`.
         *
         * @param {string} filterName - The name of the sub-filter (e.g. 'deadline')
         * @param {string} uniqueId - Unique identifier of sub-filter
         *
         * @returns {boolean|null} - This boolean is used together with an ng-show to
         *                                show or hide the filter markup, and therefore,
         *                                the possibility to use the filter.
         *
         **/
        $scope.isSubfilterVisible = (filterName, uniqueId) => {
          if ($scope.searchJs) {
            const typeFilter = $scope.searchJs.filter.type;

            if (!typeFilter.isActive()) {
              return true;
            }
            if (uniqueId === 'contractTypeFilter') {
              // If either contract or shortlist is selected, allow sub-filtering
              return typeFilter.value.some((val) => ['contract', 'shortlist'].indexOf(val) > -1);
            } else if (uniqueId === 'tgoTypeFilter') {
              // If any TGO filter is selected, allow sub-filtering
              return typeFilter.value.some((filterValue) => {
                return ['tender', 'grant', 'open_opportunity'].indexOf(filterValue) > -1;
              });
            }

            const subfilterTypes = $scope.searchJs.filter[filterName].reportTypes;
            return typeFilter.value.some((value) => subfilterTypes.indexOf(value) > -1);
          }
          return null;
        };

        /**
         * Check there is any active filter in the SearchJs instance
         *
         * @returns {boolean} - If SearchJs has any active filters, returns true
         **/
        $scope.anyActiveFilter = () => {
          if ($scope.searchJs) {
            return Object.keys($scope.searchJs.filter).some((filterKey) => {
              return $scope.searchJs.filter[filterKey].isActive();
            });
          }
        };

        /**
         * Resets all filters to their default values, except for `statuses` (force
         * 'forecast', 'open' values) `tracked_by_me` and `tracked_by_colleagues` (we do not want
         * to reset them if modified) and also set default sorting to `Publication date`.
         * Then notifiy the changes to the whole searchJs
         *
         * @returns {undefined}
         */
        $scope.clearFilters = () => {
          $scope.dateFilterService.setDate('reset');
          // eslint-disable-next-line guard-for-in
          for (let index in $scope.searchJs.filter) {
            const filter = $scope.searchJs.filter[index];

            if (index === 'statuses') {
              filter.setValue(['forecast', 'open']);
              continue;
            }

            if (index === 'tracked_by_me' || index === 'tracked_by_colleagues') {
              continue;
            }

            filter.reset();
          }

          $scope.searchJs.sorting.setParams({
            sorting: { name: 'Publication date', field: 'updated_at', order: 'desc' },
          });

          $scope.searchJs.notifyParamChange();
        };

        $scope.selectedDonors = [];
        $scope.selectedDonorCategories = [];

        /**
         * Maps a simple donor name list to a donor object list, containing
         * name and a 'checked' property to bind its value to the checkbox
         * in the template
         *
         * @param {Array} donors - List of donor names
         *
         * @returns {Array} - List of donor objects (name + short_name + checked)
         */
        const parseDonorList = (donors) => {
          return donors.map((donor) => ({
            name: donor.name,
            short_name: donor.short_name,
            checked: false,
            excluded: false, // just checked donors (true) can be excluded (true)
          }));
        };

        /**
         * Maps a category structure to add a 'checked' property to bind its
         * value to the checkbox in the template
         *
         * @param {Array} categories - Category structure to be parsed
         *
         * @returns {Array} - Parsed structure
         */
        const parseCategoriesList = (categories) => {
          return categories.map((category) => {
            const item = {
              name: category.name,
              checked: false,
              isExpanded: false,
              donors: [],
            };

            if (category.donors && category.donors.length) {
              item.donors = parseDonorList(category.donors);
            }

            return item;
          });
        };

        /**
         * For the categories that include donors, toggle the expanded panel
         * to show/hide the donors children of each category
         *
         * @param {object} donorCategory - Category structure
         *
         * @returns {undefined}
         */
        $scope.toggleExpandDonorCategory = (donorCategory) => {
          donorCategory.isExpanded = !donorCategory.isExpanded;
        };

        /**
         * If selectedDonorCategories contains this category, it marks it as checked
         *
         * Then, iterates the donors of each category, and it checks the donor if:
         * - category is checked, or
         * - donor is checked
         *
         * If selectedExcludeDonors contains this donor, it marks it as excluded
         *
         * After that, if all the donors from the category have been checked, it checks
         * also the category
         *
         * @param {object} category - Category structure (name + checked + donor list)
         *
         * @returns {undefined}
         */
        const toggleCategoriesAndDonorsBySearchFilter = (category) => {
          category.checked = $scope.selectedDonorCategories.includes(category.name);

          if ($scope.areAllDonorsChecked()) {
            category.checked = true;
          }

          category.donors.forEach((donor) => {
            donor.checked = false;
            donor.excluded = false;

            if (category.checked || $scope.selectedDonors.includes(donor.short_name)) {
              donor.checked = true;
            }

            donor.excluded = $scope.selectedExcludeDonors.includes(donor.short_name);
            if ($scope.selectedExcludeDonors.includes(donor.short_name)) {
              donor.checked = true;
            }
          });
        };

        /**
         * Iterates the categories and if they contain donors it
         * triggers toggleCategoriesAndDonorsBySearchFilter
         *
         * @returns {undefined}
         */
        const toggleBySearchFilter = () => {
          if ($scope.areAllDonorsChecked()) {
            $scope.setAllDonors(false);
          }

          $scope.donor_category_list.forEach((category) => {
            if (category.donors && category.donors.length) {
              toggleCategoriesAndDonorsBySearchFilter(category);
            }
          });
        };

        /**
         * Obtains the categories from the BE
         * It parses the BE response so it can be used properly in the
         * template
         * If there are donors applied in the filter it checks them in the
         * parsed data
         *
         * @returns {undefined}
         */
        const getDonorCategoryList = () => {
          $http({
            method: 'get',
            url: routesModule.api_path('donor_categories'),
          }).then((response) => {
            $scope.donor_category_list = parseCategoriesList(response.data);

            if ($scope.selectedDonors.length || $scope.selectedDonorCategories.length) {
              toggleBySearchFilter();
            }
          });
        };

        /**
         * Get available news_topics from BE and creates a function, that returns
         * the values with current filter values filtered.
         *
         * @returns {undefined}
         */
        const getNewsTopics = () => {
          $http.get('/api/classification/frameworks/news_topics').then((resp) => {
            $scope.newsTopics = () => {
              return resp.data.categories.filter((value) => {
                return !$scope.filterContainsValue(value, 'news_topics');
              });
            };
          });
        };

        /**
         * Triggered when clicking the 'See All' button on the template, it
         * displays the donor list modal and if it's the first time then it
         * also requests the donors to the BE
         * If not, it binds the donor filter values to the list
         *
         * @returns {undefined}
         */
        $scope.showDonorListModal = () => {
          $uibModal.open({
            templateUrl: donorListModalTemplate,
            scope: $scope,
            windowClass: 'selector-modal',
            animation: false,
          });

          if (!$scope.donor_category_list) {
            getDonorCategoryList();
          } else {
            toggleBySearchFilter();
          }
        };

        /**
         * Removes all donors and exclude_donors of a passed category from filters.
         * It is being used when a category is selected and individual donors could
         * be previously checked/excluded
         *
         * @param {object} category - Category structure (name + checked + donor list)
         *
         * @returns {undefined}
         */
        const removeDonorFiltersIncludedInCategory = (category) => {
          category.donors.forEach((donor) => {
            $scope.searchJs.filter.donors.removeValue(donor.short_name);
            $scope.searchJs.filter.exclude_donors.removeValue(donor.short_name);
          });
        };

        /**
         * For each donor contained in a category, only keep the checked and included ones
         * and add them to SearchJS donors filter
         *
         * @param {object} category - Category structure (name + checked + donor list)
         *
         * @returns {undefined}
         */
        const bindDonorsWithFilters = (category) => {
          category.donors
            .filter((donor) => donor.checked && !donor.excluded)
            .forEach((donor) =>
              $scope.searchJs.filter.donors.addValue({ short_name: donor.short_name })
            );
        };

        /**
         * For each donor contained in a category, only keep the checked and excluded ones
         * and add them to SearchJS exclude_donors filter
         *
         * @param {object} category - Category structure (name + checked + donor list)
         *
         * @returns {undefined}
         */
        const bindDonorsWithExcludedFilters = (category) => {
          category.donors
            .filter((donor) => donor.checked && donor.excluded)
            .forEach((donor) =>
              $scope.searchJs.filter.exclude_donors.addValue({ short_name: donor.short_name })
            );
        };

        /**
         * Removes current value in donors, exclude_donors and donor_category filters
         * to then set the new checked/excluded values
         *
         * @param {object} category - Category structure (name + checked + donor list)
         *
         * @returns {undefined}
         */
        const bindDonorCategoriesAndDonorsWithFilter = (category) => {
          $scope.searchJs.filter.donor_categories.removeValue(category.name);
          removeDonorFiltersIncludedInCategory(category);

          if (category.checked) {
            $scope.searchJs.filter.donor_categories.addValue({ name: category.name });
          } else {
            bindDonorsWithFilters(category);
          }

          bindDonorsWithExcludedFilters(category);
        };
        /**
         * Triggered when clicking the 'Apply' button on the modal
         * template, it triggers bindDonorCategoriesAndDonorsWithFilter for each of the
         * categories if they contain donors
         * After that it notifies to searchJs that the filters have changed
         *
         * @returns {undefined}
         */
        $scope.triggerSearch = () => {
          $scope.donor_category_list.forEach((category) => {
            if (category.donors && category.donors.length) {
              bindDonorCategoriesAndDonorsWithFilter(category);
            }
          });
          $scope.searchJs.notifyParamChange();
        };

        /**
         * Finds out if all the elements in a list are checked or not
         *
         * @param {Array} list - Donor or category structure list (name +
         *                       checked [ + donor list])
         *
         * @returns {boolean} - True if all checked (or empty) and false if not
         */
        const getCheckedList = (list) => {
          let result = true;

          if (list) {
            const checked = list.filter((item) => item.checked).length;
            result = list.length === checked;
          }

          return result;
        };

        /**
         * Listens to all the clicks on the document. If click does not happen inside `Advanced
         * filters` panel, do not hide dropdown. If click happens outside and `Advanced filters`
         * dropdown is expanded, hide it and apply scope for Angular to reset arrow and resync.
         *
         * @returns {undefined}
         */
        const listenToOutsideClicks = () => {
          $(document).click((event) => {
            const $clickTarget = $(event.target);
            const $menus = $('#advanced-filters-menu');

            if (
              $menus.hasClass('in collapse') &&
              !$clickTarget.parents('#search-bar').length &&
              !$scope.dropdowns.customDatePickerExpanded
            ) {
              $scope.dropdowns.advancedFiltersOpen = false;
              $scope.$apply();
            }
          });
        };

        /**
         * Triggered when checking a category checkbox, it checks/unchecks
         * all the donors that contains
         *
         * @param {object} category - Category structure (name + checked +
         *                            donor/category list)
         *
         * @returns {undefined}
         */
        $scope.toggleCategory = (category) => {
          if (category.donors) {
            category.donors.forEach((donor) => {
              donor.checked = category.checked;
              if (!category.checked) {
                donor.excluded = false;
              }
            });
          }
        };

        /**
         * Triggered when checking a donor checkbox
         * Sets checked category value depending on if all donors are check or not
         * When un-checking a donor, it sets excluded as default value, false
         *
         * @param {object} donor - Donor structure (which contains updated checked value)
         * @param {object} category - Category structure (name + checked + donor list)
         *
         * @returns {undefined}
         */
        $scope.toggleDonor = (donor, category) => {
          category.checked = getCheckedList(category.donors);
          if (!donor.checked) {
            donor.excluded = false;
          }
        };

        $scope.toggleExclusion = (donor) => {
          donor.excluded = !donor.excluded;
        };

        /**
         * Returns if all donors checkbox should be checked or not depending on the
         * current status of all donors checkboxes
         *
         * @returns {boolean} true if all donors are checked, otherwise false
         */
        $scope.areAllDonorsChecked = () => {
          if (!$scope.donor_category_list) return false;
          return getCheckedList($scope.donor_category_list);
        };

        /**
         * Sets donor categories and donors depending to the passed value
         *
         * @param {boolean} checked - value (true/false) to set all donors and categories
         *
         * @returns {undefined}
         */
        $scope.setAllDonors = (checked) => {
          $scope.donor_category_list.forEach((category) => {
            category.checked = checked;
            $scope.toggleCategory(category);
          });
        };

        /**
         * Toggles the advanced filters on Funding Search
         *
         * @returns {undefined}
         */
        $scope.toggleAdvancedFilters = () => {
          $scope.dropdowns.advancedFiltersOpen = !$scope.dropdowns.advancedFiltersOpen;
        };

        const init = () => {
          $scope.selectedDonors = $scope.searchJs.filter.donors.getValue();
          $scope.selectedExcludeDonors = $scope.searchJs.filter.exclude_donors.getValue();
          $scope.selectedDonorCategories = $scope.searchJs.filter.donor_categories.getValue();

          defineCheckboxFilters();
          parseCheckboxFilter();
          listenToOutsideClicks();
          getNewsTopics();
          $scope.datePickerOptions = { maxDate: new Date() };
          $scope.dateFilterService = dateFilterService;
        };

        $scope.$watch('searchJs', (searchJs) => {
          if (searchJs) {
            init();

            /**
             * Whenever the searchJs params changes we check if the donor category, donor or
             * exclude_donor filter have a different value than we have stored and it applies
             * that new value to the category / donor list, and sets `removeReportParamFromUrl`
             * to `true` to replace activeReport by visualizations
             */
            $scope.searchJs.on('paramChange', () => {
              const donors = $scope.searchJs.filter.donors.getValue();
              const excludeDonors = $scope.searchJs.filter.exclude_donors.getValue();
              const donorCategories = $scope.searchJs.filter.donor_categories.getValue();

              if ($scope.selectedExcludeDonors !== excludeDonors) {
                $scope.selectedExcludeDonors = excludeDonors;
              }
              if (
                $scope.selectedDonors !== donors ||
                $scope.selectedDonorCategories !== donorCategories
              ) {
                $scope.selectedDonors = donors;
                $scope.selectedDonorCategories = donorCategories;

                if (!$scope.donor_category_list) {
                  getDonorCategoryList();
                } else {
                  toggleBySearchFilter();
                }
              }
              bindCheckboxFiltersOptionsWithSearchJsFilters();
              if (!$scope.isFirstBookmarkedSearchFn()) {
                $scope.removeReportParamFromUrl = true;
              }
            });
          }
        });
      };

      return {
        restrict: 'E',
        templateUrl: template,
        scope: {
          userPermissions: '=',
          searchJs: '=',
          removeReportParamFromUrl: '=',
          isFirstBookmarkedSearchFn: '=',
        },
        link,
      };
    },
  ]);
